export const isInViewport = (elem, threshold = 0) => {
  var bounding = elem.getBoundingClientRect();
  return (
    bounding.top - threshold >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom - threshold <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  );
};
